import type { InvoiceQuerySchema } from '../../shared';

export type CsvRow = Record<string, string | number | null | undefined>;

export function buildAllInvoicesExportRows(invoices: InvoiceQuerySchema[]): CsvRow[] {
  return invoices.map((invoice) => {
    const amountDue = invoice.account_receivables?.balance_due ?? 0;
    // invoice.account_receivables?.reduce<number | null>((sum, ar) => {
    //   if (ar.balance_due == null) return sum;
    //   return (sum ?? 0) + ar.balance_due;
    // }, null) ?? null;

    return {
      'Account #': invoice.client?.account_number ?? null,
      'Company Name': invoice.client?.name ?? null,
      'Invoice #': invoice.invoice_number,
      Amount: invoice.invoice_amount,
      'Amount Due': amountDue,
      Status: invoice.status,
    };
  });
}
